<div class="drawer z-20">
  <input id="my-drawer" type="checkbox" class="drawer-toggle" />
  <div class="drawer-content">
    <!-- Page content here -->
    <label for="my-drawer" class="drawer-button p-2">
      <ng-icon
        name="phosphorSidebarFill"
        class="text-2xl text-black rounded-4xl mt-4 cursor-pointer"
      ></ng-icon>
    </label>
  </div>
  <div class="drawer-side">
    <label
      for="my-drawer"
      aria-label="close sidebar"
      class="drawer-overlay"
    ></label>
    <div
      class="flex flex-col h-full w-80 bg-white backdrop-blur-xl border-r border-gray-700/30 shadow-xl"
    >
      <!-- Sidebar Header -->
      <div class="border-b border-gray-700/30 flex justify-end">
        <label
          for="my-drawer"
          class="cursor-pointer hover:bg-gray-700/20 p-2 rounded-lg"
        >
          <ng-icon name="phosphorSidebarSimpleFill" class="text-2xl"></ng-icon>
        </label>
      </div>

      <!-- Chats Section -->
      <div class="flex-1 overflow-y-auto p-1">
        <nav class="mb-4">
          <ul class="space-y-1">
            <li>
              <a
                class="flex items-center gap-2 p-1.5 rounded-lg hover:bg-blue-500/10 transition-all cursor-pointer"
                (click)="data?.onNewItem()"
              >
                <ng-icon name="heroPlus" class="text-sm text-black"></ng-icon>
                <span class="text-black text-sm font-medium">{{ data?.newItemName }}</span>
              </a>
            </li>
          </ul>
        </nav>
        <h2 class="text-sm font-bold text-black mb-2">
          {{ data?.recentItemsName }}
        </h2>
        <ul class="space-y-1 max-h-auto overflow-y-auto custom-scrollbar">
          @for (item of (data?.items); track item.id; let i = $index) {
            <li
              class="px-2 pt-2 text-xs font-semibold text-black uppercase"
              *ngIf="item.source === 'local' &&
                (i === 0 || data?.items?.[i - 1]?.source !== 'local')"
            >Local</li>
            <li
              class="px-2 pt-2 text-xs font-semibold text-black uppercase"
              *ngIf="item.source === 'cloud' &&
                (i === 0 || data?.items?.[i - 1]?.source !== 'cloud')"
            >Cloud</li>
            <li>
              <a
                class="flex items-center gap-2 p-1.5 rounded-lg hover:bg-blue-500/10 transition-all cursor-pointer group"
                (click)="item.source ? data?.onClick(item.id, item.source) : data?.onClick(item.id)"
              >
                <ng-icon
                  name="heroChatBubbleLeftRight"
                  class="text-blue-600 text-sm group-hover:text-blue-700 transition-colors"
                ></ng-icon>
                <span
                  class="text-gray-700 text-sm font-medium truncate group-hover:text-gray-900 transition-colors"
                >
                  {{ item.label }}
                </span>
                <span
                  *ngIf="
                    item.source === 'cloud' && item.id === selectedRepoId?.id && !isStudyConnected
                  "
                  class="ml-auto flex items-center"
                >
                  <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-black!"></div>
                </span>
              </a>
            </li>
          }
          <!-- <li (click)="getChats()"> Test Button </li> -->
        </ul>
      </div>
    </div>
  </div>
</div>
<app-create-repo></app-create-repo>
